export default __webpack_public_path__ + "static/media/330_dummy2016-tennisclub01-de.e78b53dc.png";